<template>
  <div class="media-item" @click="$emit('select')">
    <div v-if="showMore" class="gray-overlay">
      <FriedH1>+{{ showMore }}</FriedH1>
    </div>
    <FriedSpinner v-if="!url" class="media-loader media-content" />
    <img
      v-else-if="media.imageId"
      :class="[
        'media-content',
        {
          'cover-fit': coverFit,
        },
      ]"
      :src="url"
      @error="$emit('media-load-error')"
    />
    <VideoPlayer
      v-else-if="media.videoId"
      :url="url"
      :controls="controls"
      :play-on-hover="playOnHover"
      :click-to-play="clickToPlay"
      :autoplay="autoplay"
      ratio="16:9"
      :muted="muted"
      class="video-player"
      @error="$emit('media-load-error')"
    />
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { onMounted, watch, ref, defineComponent } from 'vue';
import VideoPlayer from '@getaccept/lib-shared-new/src/video/player/components/VideoPlayer.vue';
import type { PostMedia } from '../../types/post';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    media: {
      type: Object as PropType<PostMedia>,
      required: true,
    },
    controls: {
      type: Boolean,
    },
    clickToPlay: {
      type: Boolean,
    },
    playOnHover: {
      type: Boolean,
    },
    showMore: {
      type: Number,
      default: 0,
    },
    autoplay: {
      type: Boolean,
    },
    muted: {
      type: Boolean,
    },
    coverFit: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const url = ref(null);

    watch(
      () => props.media.url,
      (mediaUrl: string) => {
        if (mediaUrl) {
          url.value = mediaUrl;
        }
      }
    );

    onMounted(() => {
      if (props.media.url) {
        url.value = props.media.url;
      }
    });

    return {
      url,
    };
  },
});
</script>
<style lang="scss" scoped>
$uploaded-media-height: 12rem;

.media-item {
  position: relative;
  max-height: $uploaded-media-height;
  display: flex;
  border-radius: var(--radius-medium);
  overflow: hidden;
  background: var(--gray-96);
  align-items: center;
  aspect-ratio: 16 / 9;

  .gray-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    aspect-ratio: 16 / 9;
    background: rgb(44 59 78 / 60%);
    display: flex;
    justify-content: center;

    > h1 {
      color: var(--white);
      text-align: center;
      margin: auto;
    }
  }

  .video-player {
    display: flex;
    justify-content: center;

    &.video-player-container {
      :deep(.plyr) {
        min-width: 100%;
      }
    }
  }

  .media-content {
    height: 100%;
    max-width: 100%;
    aspect-ratio: 16 / 9;
    object-fit: contain;

    &.cover-fit {
      object-fit: cover;
    }
  }

  .media-loader {
    align-items: center;
  }

  img {
    margin: auto;
    object-fit: contain;
  }
}
</style>
